// src/com/file_of_report/StoreTransReportDef.js
// 점포운송 레포트 정의
// 운송사는 해당 없음.

import { AppWord, TableColumnType } from "../../value/AppConst";
import ValueMisc from "../../value/ValueMisc";


export const StoreTransReportMeta = {
    instructions: {
        title: '점포운송 Report',
        headerRowSpan: 1,
        headerRows: [],
        headerBackgroundColor: 'FF66CCFF', // light blue (exceljs)
    },
    getExtraHeaders: (records) => ValueMisc.makeDurationHeader(records),
};

// width는 8의 배수가 좋아. 40, 48, 56, 64, 72, 80, 88, 96, 104, 112, 120, 128, 136, 144, 152, 160, 168..

// 점포운송 레포트 엑셀 컬럼 정의
export const StoreTransReportExcelColumns = [
    { id: 'dcTypeName', width: 96, label: 'DC 구분', option:{type:TableColumnType.TEXT} },
    { id: 'planId', width: 120, label: '의뢰번호', option:{type:TableColumnType.TEXT} },
    {
        id: 'dcName', width: 104, label: '출발지',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER}
    },
    { id: 'storeName', width: 104, label: '도착지', option:{type:TableColumnType.TEXT} },
    {
        id: 'hocha', width: 40, label: '호차', noTotal: true,
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    { id: 'vehTypeName', width: 96, label: '차종', option:{type:TableColumnType.TEXT} },
    {
        id: 'vehPlates', width: 128, label: '차량번호',
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    { id: 'comName', width: 152, label: '운송사', option:{type:TableColumnType.TEXT} },
    { id: 'driverName', width: 104, label: '기사명', option:{type:TableColumnType.TEXT} },
    {
        id: 'prosDptrTime', width: 152, label: '출발예상시간',
        option:{align: AppWord.CENTER, type:TableColumnType.DATETIME}
    },
    {
        id: 'prosArrTime', width: 152, label: '도착예정시간',
        option:{align: AppWord.CENTER, type:TableColumnType.DATETIME}
    },
    {
        id: 'inputArrTime', width: 152, label: '실제차량도착시간',
        option:{align: AppWord.CENTER, type:TableColumnType.DATETIME}
    },
    {
        id: 'insertTime', width: 152, label: '등록일',
        option:{align: AppWord.CENTER, type:TableColumnType.DATETIME}
    },
    { id: 'regUserName', width: 96, label: '등록자', option:{type:TableColumnType.TEXT} },
    {
        id: 'inputBool', width: 112, label: '점포입력여부',
        option:{align: AppWord.CENTER, type:TableColumnType.BOOLEAN},
        excel: (row, value) => value ? '입력' : '미입력'
    },
    {
        id: 'returnDriverCheckYn', width: 144, label: '반납집기운전원인수',
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    {
        id: 'returnDcCheckUserName', width: 136, label: '센터집기확인자',
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    {
        id: 'dcReturnKpp', width: 80, label: 'KPP',
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    {
        id: 'dcReturnAju', width: 80, label: 'AJU',
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    {
        id: 'dcReturnSpt', width: 96, label: '녹색(532)',
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    {
        id: 'dcReturnSpt533', width: 96, label: '보라색(533)',
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    {
        id: 'dcReturnFull', width: 80, label: 'Full',
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    {
        id: 'dcReturnHalf', width: 80, label: 'Half',
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    {
        id: 'dcReturnNjc800', width: 96, label: 'NJC 800',
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    {
        id: 'dcReturnRollcage', width: 112, label: 'Roll Cage',
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    {
        id: 'dcReturnDanpra', width: 128, label: 'Danpra(고가 Box)',
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    {
        id: 'dcReturnWooden', width: 96, label: '우든칼라',
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    {
        id: 'dcReturnOctagon', width: 96, label: '옥타곤',
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    {
        id: 'dcReturnStackKpp', width: 112, label: '집기적재KPP',
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    {
        id: 'dcReturnStackAju', width: 112, label: '집기적재AJU',
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    {
        id: 'dcReturnEtc', width: 80, label: '기타',
        option:{align: AppWord.CENTER, type:TableColumnType.INTEGER}
    },
    {
        id: 'dcCoverStores', width: 144, label: '점간대출 점포(532)',
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    {
        id: 'dcReturnSealNo', width: 72, label: '봉인번호',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER}
    },
    {
        id: 'dcReturnSealNo2', width: 72, label: '봉인번호2',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER}
    },
    {
        id: 'dcReturnSealNo3', width: 72, label: '봉인번호3',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER}
    },
    {
        id: 'dcCoverItem1', width: 72, label: 'PT',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER}
    },
    {
        id: 'dcCoverItem2', width: 96, label: 'RollCage',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER}
    },
    {
        id: 'dcNoReturnCode', width: 144, label: '반납정보 미입력 코드',
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    {
        id: 'dcNoReturnNote', width: 160, label: '반납정보 미입력 내용',
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    {
        id: 'dcNoReturnDate', width: 160, label: '반납정보 미입력 일자',
        option:{align: AppWord.CENTER, type:TableColumnType.DATETIME}
    },
    {
        id: 'dcNoReturnUser', width: 160, label: '반납정보 미입력 작성자',
        option:{align: AppWord.CENTER, type:TableColumnType.TEXT}
    },
    {
        id: 'dcReturnNote', width: 160, label: '비고',
        option:{type:TableColumnType.TEXT}
    },
    { id: 'aPalKpp', width: 112, label: '물류집기KPP', option:{type:TableColumnType.INTEGER} },
    { id: 'aPalAju', width: 112, label: '물류집기AJU', option:{type:TableColumnType.INTEGER} }
];
